import {
  Component,
  inject,
  viewChild,
  computed,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { MibButtonDirective, MibLogoMedinboxComponent, MibModalComponent } from '@medinbox/angular';
import { GuestDisclaimerForm, GuestFormData } from './guest-disclaimer-form/guest-disclaimer-form';
import { SharedVideoId } from '@shared/models/user/shared-video-id';

export interface DisclaimerData {
  showGuestForm?: boolean;
  formData?: GuestFormData;
  videoIds?: SharedVideoId[];
}

@Component({
  selector: 'mai-disclaimer',
  imports: [MibModalComponent, MibLogoMedinboxComponent, MibButtonDirective, GuestDisclaimerForm],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './disclaimer.html',
})
export class Disclaimer {
  readonly dialogRef = inject(DialogRef<GuestFormData | boolean>);
  readonly data = inject<DisclaimerData>(DIALOG_DATA, { optional: true });

  showGuestForm = signal(this.data?.showGuestForm ?? false);

  // Access the guest form component
  guestFormComponent = viewChild(GuestDisclaimerForm);

  // Computed signal to check if the form is valid
  isFormValid = computed(() => {
    const form = this.guestFormComponent()?.guestForm;
    if (!form) return false;

    // Check if all fields are valid
    return form.email().valid() && form.lastname().valid() && form.firstname().valid();
  });

  onGuestFormSubmitted(formData: GuestFormData): void {
    // Guest form submission - return the form data to the caller
    this.dialogRef.close(formData);
  }

  onAccept(): void {
    if (this.showGuestForm()) {
      // For guests, trigger form submission
      this.guestFormComponent()?.submitForm();
    } else {
      // For regular users, just close with true
      this.dialogRef.close(true);
    }
  }

  onRefuse(): void {
    this.dialogRef.close(false);
  }
}
